<template>
  <list-filter
    class="trash-filter"
    :leftName="leftName"
    :rightName="$t('file.trash.filter')"
    :arrowUp="showActionSheet"
    @filter-click="onFilterClick"
  />
</template>
<script>
import ajax from '@/utils/ajax'
import {i18n} from '@/utils/i18n'
import {EXTERNAL_ENTERPRISES} from '@/config/api'
import ListFilter from '../utils/ListFilter'

// TODO:列表为空时 不显示该组件内容
export default {
  name: 'TrashFilter',
  i18n,
  components: {
    ListFilter
  },
  props: ['trashFilterSelected', 'showActionSheet'],
  data () {
    return {
      trashFilterList: [{id: 'my_0', name: i18n.t('file.myEnterprise')}]
    }
  },
  computed: {
    leftName () {
      return this.trashFilterList.find(item => item.id === this.trashFilterSelected).name
    }
  },
  created () {
    this.getExternalEnterprises()
  },
  methods: {
    getExternalEnterprises () {
      ajax({
        url: EXTERNAL_ENTERPRISES
      }).then(res => {
        if (res && res.external_list) {
          this.trashFilterList = this.trashFilterList.concat(res.external_list.map(item => {
            item.id = `${item.type}_${item.id}`
            return item
          }))
          this.$emit('trash-filter-list', this.trashFilterList)
        }
      })
    },
    onFilterClick () {
      this.$emit('menu-click', {}, 'trash-filter')
    }
  }
}
</script>
